/**
 * TrustedSiteBadge — floating verification badge from TrustedSite.com.
 *
 * Activates ONLY when `REACT_APP_TRUSTEDSITE_META_ID` is set in the
 * production frontend env. When missing (preview, local dev), the
 * component renders nothing so we never ship a broken/empty badge.
 *
 * Setup:
 *   1. Go to https://www.trustedsite.com and sign up (free tier includes
 *      the "Certified Secure" badge).
 *   2. Add your domain (centralrentals.ca) and complete verification.
 *   3. TrustedSite gives you a Meta ID string (looks like: "abc1234xyz").
 *   4. Add to your production env:
 *        REACT_APP_TRUSTEDSITE_META_ID=abc1234xyz
 *      then redeploy.
 *
 * The component injects:
 *   <meta name="ts-meta" content="{id}">
 *   <script src="https://cdn.ywxi.net/js/1.js" async>
 * exactly as TrustedSite documents — no custom UI, so the badge always
 * looks and behaves like the official one on your Edmonton site.
 */
import { useEffect } from "react";

const TS_ID = (process.env.REACT_APP_TRUSTEDSITE_META_ID || "").trim();

export default function TrustedSiteBadge() {
  useEffect(() => {
    if (!TS_ID) return;
    if (typeof document === "undefined") return;

    // Avoid double-injection on hot-reload / route re-mounts.
    const existingMeta = document.querySelector('meta[name="ts-meta"]');
    if (!existingMeta) {
      const meta = document.createElement("meta");
      meta.name = "ts-meta";
      meta.content = TS_ID;
      document.head.appendChild(meta);
    }

    const existingScript = document.querySelector('script[data-crc-trustedsite]');
    if (!existingScript) {
      const s = document.createElement("script");
      s.src = "https://cdn.ywxi.net/js/1.js";
      s.async = true;
      s.setAttribute("data-crc-trustedsite", "1");
      document.body.appendChild(s);
    }
  }, []);

  return null;
}
